import React from 'react';
import PropTypes from 'prop-types';
import { getClassName } from 'utils/ui/classes';
const DownloadIcon = ({ className, size }) => {
    if (size === 'small') {
        return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: getClassName(className), viewBox: "0 0 20 20", fill: "currentColor" },
            React.createElement("path", { fillRule: "evenodd", d: "M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z", clipRule: "evenodd" })));
    }
    return (React.createElement("svg", { className: getClassName(className), xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor" },
        React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" })));
};
DownloadIcon.propTypes = {
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
    ]),
    size: PropTypes.oneOf(['small', 'medium']),
};
DownloadIcon.defaultProps = {
    className: 'w-5 h-5',
    size: 'small',
};
export default DownloadIcon;
